import axios from 'axios';

export default {
  get: () => axios.get('/api/v1/avg/planned-values'),
  create: (params) => axios.post('/api/v1/avg/planned-values', params),
};
